import { Component, Inject, OnInit, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface GalleryImage {
    url: string;
    title?: string;
}

@Component({
    selector: 'sd-epk-gallery-dialog',
    templateUrl: './epk-gallery-dialog.component.html',
    styleUrls: ['./epk-gallery-dialog.component.scss']
})
export class EpkGalleryDialogComponent implements OnInit {
    currentIndex = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { images: (string | GalleryImage)[], startIndex?: number },
        private dialogRef: MatDialogRef<EpkGalleryDialogComponent>
    ) {}

    ngOnInit() {
        if (this.data.startIndex) {
            this.currentIndex = this.data.startIndex;
        }
    }

    // Keyboard support for Left/Right arrows
    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.key === 'ArrowLeft') {
            this.prevPhoto();
        } else if (event.key === 'ArrowRight') {
            this.nextPhoto();
        }
    }

    prevPhoto() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        }
    }

    nextPhoto() {
        if (this.currentIndex < this.data.images.length - 1) {
            this.currentIndex++;
        }
    }

    getCurrentImageUrl(): string {
        const img = this.data.images[this.currentIndex];
        return typeof img === 'string' ? img : img.url;
    }

    getCurrentImageTitle(): string {
        const img = this.data.images[this.currentIndex];
        return typeof img === 'string' ? 'Photo' : (img.title || 'Photo');
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
